import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const FormFilter = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='FormFilter' {...props}>
    <polygon fill='none' stroke='#000' strokeWidth='2' points='6 8 11.667 12.667 11.667 18 12.333 18 12.333 12.667 18 8 18 6 6 6' />
  </StyledIcon>
);
